import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatRippleModule } from "@angular/material/core";
import { MatGridListModule } from "@angular/material/grid-list";
import { RouterModule } from "@angular/router";
import { RssFeedDashboardWidgetComponent } from "@app/dashboard/components/rss-feed-dashboard-widget/rss-feed-dashboard-widget.component";
import { RSSFeedService } from "@app/dashboard/services/rss-feed.service";
import { ProjectStatusService } from "@app/project/services/project-status.service";
import { ServicePlansService } from "@app/project/services/service-plans.service";
import { RalinkDatabaseService } from "@app/shared/databases/ralink.database";
import { CallbackPipe } from "@app/shared/resources/callback.pipe";
import { StatusCountService } from "@app/shared/services/status-count.service";
import { NgxPermissionsModule } from "ngx-permissions";
import { SharedModule } from "../shared/shared.module";
import { AccountSearchComponent } from "./components/account-search/account-search.component";
import { DashboardHomeComponent } from "./components/home/home.component";

@NgModule({
    imports: [CommonModule, FlexLayoutModule, MatGridListModule, MatRippleModule, NgxPermissionsModule, RouterModule, SharedModule],
    declarations: [CallbackPipe, AccountSearchComponent, DashboardHomeComponent, RssFeedDashboardWidgetComponent],
    providers: [ProjectStatusService, RalinkDatabaseService, RSSFeedService, ServicePlansService, StatusCountService],
})
export class DashboardModule {}
